import script from "./PartnerSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerSelect.vue?vue&type=script&setup=true&lang=js"

import "./PartnerSelect.vue?vue&type=style&index=0&id=e2b97e72&lang=css"

const __exports__ = script;

export default __exports__